<template>
  <v-item-group>
    <v-item class="mb-1">
      <v-hover v-slot="{ hover }">
        <v-card :elevation="hover ? 20 : 0">
          <v-list two-line>
            <v-list-item>
              <v-list-item-content>
                <v-autocomplete
                  v-model="address"
                  :label="$t('inputs.location')"
                  :items="locationFoundItems"
                  :search-input.sync="locationSearchText"
                  item-text="value"
                  hide-no-data
                  :loading="$store.getters.isLoading"
                  :disabled="$store.getters.isLoading"
                  filled
                  clearable
                  :readonly="isLocationActive"
                  class="search-input"
                >
                  <template v-slot:prepend>
                    <v-slide-x-reverse-transition mode="out-in">
                      <v-icon
                        :key="`icon-${isLocationActive}`"
                        :color="isLocationActive ? 'primary' : 'gray'"
                        @click="isLocationActive = !isLocationActive"
                        v-text="
                          isLocationActive
                            ? 'mdi-map-marker-radius'
                            : 'mdi-map-marker-off'
                        "
                      />
                    </v-slide-x-reverse-transition>
                  </template>
                </v-autocomplete>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-hover>
    </v-item>
  </v-item-group>
</template>

<script>
import { GetSuggestions, GetGeocoder } from "@/utils/places-utils";

export default {
  name: "PlaceAutocompleteNearStore",
  data: () => ({
    address: null,
    locationSearchText: null,
    locationEntries: [],
    isLoading: false,
    isLocationActive: false,
  }),
  computed: {
    locationFoundItems() {
      return this.locationEntries;
    },
  },
  watch: {
    locationSearchText: function (newVal) {
      const self = this;
      if (!this.isLocationActive) {
        // If less than 3 chars typed, do not search
        if (!newVal || newVal.length <= 3) return;
        self.isLoading = true;
        // Call the method from the previous section here
        GetSuggestions(newVal)
          .then(function (res) {
            if (res) {
              setTimeout(() => {
                self.locationEntries = res;
              }, 200);
            } else {
              self.locationEntries = [];
            }
          })
          .catch(function (error) {
            console.log(error);
            // error handling goes here
          });
        setTimeout(() => {
          self.isLoading = false;
        }, 500);
      }
    },
    isLocationActive: function (value) {
      this.locationEntries = [];
      if (value) {
        this.locatorButtonPressed();
      } else {
        this.address = null;
      }
    },
    address: function () {
      if (this.address) {
        this.getNearStore(this.address);
      }
    },
  },

  methods: {
    locatorButtonPressed: function () {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.getStreetAddressFrom(
            position.coords.latitude,
            position.coords.longitude
          );
        },
        (error) => {
          console.log(error.message);
        }
      );
    },
    getStreetAddressFrom: async function (lat, lng) {
      const self = this;
      GetGeocoder(lat, lng)
        .then(function (res) {
          self.address = res;
          self.locationEntries.push(res);
        })
        .catch(function (error) {
          console.log(error);
          // error handling goes here
        });
    },
    getNearStore: async function (address) {
      const self = this;
      //TODO:Submit button
      self.$store.dispatch("loading/start");
      const { data } = await axios.get("/app/nearby/store", {
        params: { location: address },
      });
      setTimeout(() => {
        self.$router.push({
          name: "Discovery",
          params: { id: data.data.slug },
        });
        self.$store.dispatch("loading/done");
      }, 700);
    },
  },
};
</script>
